import { State } from '../state';

export const inventory: State = {
    url: 'inventory'
};

export const inventoryGoodsIssue: State = {
    url: 'inventory/goods-issue'
};

export const inventoryGoodsIssueNew: State = {
    url: 'inventory/goods-issue/new',
    parent: inventoryGoodsIssue
};

export const inventoryGoodsIssueEdit: State = {
    url: 'inventory/goods-issue/edit',
    parent: inventoryGoodsIssue
};

export const inventoryGoodsIssueAdjustmentNew: State = {
    url: 'inventory/goods-issue-adjustment/new',
    parent: inventoryGoodsIssue
};

export const inventoryGoodsIssueAdjustmentEdit: State = {
    url: 'inventory/goods-issue-adjustment/edit',
    parent: inventoryGoodsIssue
};

export const inventoryGoodsReceipt: State = {
    url: 'inventory/goods-receipt'
};

export const inventoryGoodsReceiptNew: State = {
    url: 'inventory/goods-receipt/new',
    parent: inventoryGoodsReceipt
};

export const inventoryGoodsReceiptEdit: State = {
    url: 'inventory/goods-receipt/edit',
    parent: inventoryGoodsReceipt
};

export const inventoryGoodsReceiptAdjustmentNew: State = {
    url: 'inventory/goods-receipt-adjustment/new',
    parent: inventoryGoodsReceipt
};

export const inventoryGoodsReceiptAdjustmentEdit: State = {
    url: 'inventory/goods-receipt-adjustment/edit',
    parent: inventoryGoodsReceipt
};

export const inventoryLevel: State = {
    url: 'inventory/stock-level'
};

export const inventoryMovementReport: State = {
    parent: inventoryLevel,
    url: 'inventory/movement-report'
};

export const inventoryStocktaking: State = {
    url: 'inventory/stocktaking'
};

export const inventoryStocktakingNew: State = {
    url: 'inventory/stocktaking/new',
    parent: inventoryStocktaking
};

export const inventoryStocktakingEdit: State = {
    url: 'inventory/stocktaking/edit',
    parent: inventoryStocktaking
};
